<div fxLayout="row" fxLayoutAlign="space-between center" class="p-2">
    <div fxLayout="row">
        <mat-button-toggle-group #controls="matButtonToggleGroup" appearance="legacy">            

            <mat-button-toggle value="search">
                <mat-icon>search</mat-icon>
            </mat-button-toggle>           
        </mat-button-toggle-group>            
    </div>
    <form class="user-search" [class.show]="controls.value == 'search'">
        <mat-form-field class="user-search-input">
            <input matInput placeholder="Recherche un utilisateur..." [(ngModel)]="searchText" name="search" (keyup)="fliterDataSource($event)">
        </mat-form-field>
    </form>
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <mat-button-toggle-group [(ngModel)]="typeGrid" #viewType="matButtonToggleGroup" appearance="legacy" value="grid">            
            <mat-button-toggle value="grid">
                <mat-icon>view_module</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle value="list">
                <mat-icon>view_list</mat-icon>
            </mat-button-toggle>           
        </mat-button-toggle-group>
    </div>
</div>

<div *ngIf="viewType.value == 'grid'" fxLayout="row wrap">    
    <div *ngFor="let user of users | UserSearchPipe : searchText | paginate: { itemsPerPage: 6, currentPage: page }" fxFlex="100" fxFlex.gt-md="33.3" fxFlex.md="50" class="p-2"> 
        <mat-card class="p-0 card-user">  
            <div class="bg-primary" fxLayout="row" fxLayoutAlign="space-between right">
                <h3 *ngIf="!user.user_verify"  class="user-name">{{user.user_name}} {{user.email}}</h3> 
                <h3 *ngIf="user.user_verify" class="user-name">User blocked</h3>
                <button mat-icon-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
                    <mat-icon>more_vert</mat-icon>
                </button>
            </div>
            <mat-menu #menu="matMenu" xPosition="before" overlapTrigger="true">
                <span (mouseleave)="menuTrigger.closeMenu()">
                    <button mat-menu-item (click)="detailOfUser(user.id)">
                        <mat-icon>info</mat-icon>
                        <span>Info</span>
                    </button>
                    <button mat-menu-item (click)="sendEmailOfUsers(user)">
                        <mat-icon>send</mat-icon>
                        <span>Mail</span>
                    </button>
                    <button mat-menu-item (click)="deleteUser(user);">
                        <mat-icon>delete</mat-icon>
                        <span>supprimer</span>
                    </button>
                </span>
            </mat-menu>
            <div class="user-content" fxLayout="row" fxLayoutAlign="space-around center" >
                <div fxFlex="30" fxLayout="column" fxLayoutAlign="center center">
                    <div class="user-img">
                        <img *ngIf="user.user_image" src={{hostService.getHttpsImage()+user.user_image}} class="transition-2" [class.blocked]="user.user_verify">
                        <img *ngIf="!user.user_image" src="assets/images/others/user.jpg" class="transition-2" [class.blocked]="user.user_verify">  
                        <mat-icon *ngIf="user.user_verify" color="warn">block</mat-icon>
                    </div>       
                    <!-- <div class="user-social">
                        <mat-slide-toggle  [(ngModel)]="user.user_verify" color="primary"  (change)="onChange($event)" >
                        </mat-slide-toggle>
                    </div>                                      -->
                    <div class="user-social">
                        <mat-slide-toggle color="primary" [(ngModel)]="user.user_status" (change)="onChange($event, user.id) " matTooltip="Bloquez ou Débloquez"></mat-slide-toggle>
                    </div>
                </div>
                <div fxFlex="70" fxLayout="column" class="user-details transition-2">
                    <p fxLayout="row" fxLayoutAlign="start center" (click)="detailOfUser(user.id)" matTooltip="Cliquez pour plus de détails sur l'utilisateur">
                        <mat-icon class="text-muted" >card_membership</mat-icon>
                        <span>{{user.user_name}}</span>
                    </p>
                    <p fxLayout="row" fxLayoutAlign="start center" (click)="sendEmailOfUsers(user)" matTooltip="Cliquez pour envoyer un mail à l'utilisateur">
                        <mat-icon class="text-muted" >mail_outline</mat-icon>
                        <span>{{user.email}}</span>
                    </p>
                    <p fxLayout="row" fxLayoutAlign="start center">
                        <mat-icon class="text-muted">call</mat-icon>
                        <span>{{user.user_phone}}</span>
                    </p>
                    <p fxLayout="row" fxLayoutAlign="start center">
                        <mat-icon class="text-muted">location_on</mat-icon>
                        <span>{{user.user_city}}</span>
                    </p>
                    <p fxLayout="row" fxLayoutAlign="start center">
                        <mat-icon class="text-muted">date_range</mat-icon>
                        <span>Joined {{user.created_at | date:"dd MMMM, yyyy 'at' HH:mm"}}</span>
                    </p>
                    <p fxLayout="row" fxLayoutAlign="start center">
                        <mat-icon class="text-muted">person</mat-icon>
                        <span *ngIf="user.user_profil == 'USER'">Utilisateur</span>
                        <span *ngIf="user.user_profil == 'ADMIN'">Administrateur</span>
                    </p>
                </div>
            </div>
        </mat-card>
    </div>
</div>

<div *ngIf="viewType.value == 'list'" fxLayout="row wrap">

    <div fxFlex="100" fxFlex.gt-md="100" fxFlex.md="100" class="p-2">
        <mat-card class="p-0">
            <div class="table-wrapper">

                <table mat-table [dataSource]="dataSource" matSort class="w-100">
                    <!-- FullName Column -->        
                    <ng-container matColumnDef="image">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Profil </th>
                        <td mat-cell *matCellDef="let user">
                            <div class="user-img-table">
                                <img *ngIf="user.user_image" src={{hostService.getHttpsImage()+user.user_image}} class="transition-2" [class.blocked]="user.user_verify">
                                <img *ngIf="!user.user_image" src="assets/images/others/user.jpg" class="transition-2" [class.blocked]="user.user_verify">  
                                <mat-icon *ngIf="user.user_verify" color="warn">block</mat-icon>
                            </div> 
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Nom</th>
                        <td mat-cell *matCellDef="let user">{{user.user_name}}</td>
                    </ng-container>
                    <ng-container matColumnDef="email">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Email</th>
                        <td mat-cell *matCellDef="let user">{{user.email}}</td>
                    </ng-container>
                    <ng-container matColumnDef="phone">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Téléphone</th>
                        <td mat-cell *matCellDef="let user">{{user.user_phone}}</td>
                    </ng-container>
                    <ng-container matColumnDef="location">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Ville</th>
                        <td mat-cell *matCellDef="let user">{{user.user_city}}</td>
                    </ng-container>
                    <ng-container matColumnDef="date">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Enregistrée le</th>
                        <td mat-cell *matCellDef="let user">{{user.created_at | date:"dd MMMM, yyyy 'at' HH:mm"}}</td>
                    </ng-container>
                    <ng-container matColumnDef="role">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Rôle</th>
                        <td mat-cell *matCellDef="let user">
                            <span *ngIf="user.user_profil == 'USER'">Utilisateur</span>
                            <span *ngIf="user.user_profil == 'ADMIN'">Administrateur</span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="etat">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let user">
                            <h3>{{user.user_verify==0?"Actif":"Bloqué"}}</h3>
                            <mat-slide-toggle color="primary" [(ngModel)]="user.user_status" (change)="onChange($event, user.id) " ></mat-slide-toggle>
                        </td>
                    </ng-container>
                    <!-- Actions Column -->
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef  > Actions </th>
                        <td mat-cell *matCellDef="let user">
                            <button mat-icon-button color="primary" [matMenuTriggerFor]="menuDataSource" #menuTrigger="matMenuTrigger" matTooltip="Modifier le profil de l'utilisateur">
                                <mat-icon> border_color</mat-icon>
                            </button>
                            <mat-menu #menuDataSource="matMenu" xPosition="before">
                                <span mat-menu-item (click)="changeProfil('USER', user.id, 'Utilisateur')">Utilisateur</span>
                                <span mat-menu-item (click)="changeProfil('ADMIN', user.id, 'Administrateur')">Administrateur</span>
                            </mat-menu>
                            <button mat-icon-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu" xPosition="before" overlapTrigger="true">
                                <span (mouseleave)="menuTrigger.closeMenu()">
                                    <button  (click)="detailOfUser(user.id)" mat-menu-item  color="accent" matTooltip="Plus de détails sur l'utilisateur">
                                        <mat-icon>info</mat-icon>
                                        <span>Info</span>
                                    </button>
                                    <button mat-menu-item color="warn" (click)="deleteUser(user.id)" matTooltip="Supprimer">
                                        <mat-icon>delete</mat-icon>
                                        <span>Supprimer</span>
                                    </button>
                                    <button mat-menu-item color="primary" (click)="sendEmailOfUsers(user)" matTooltip="Envoyer un mail">
                                        <mat-icon>send</mat-icon>
                                        <span>Mail</span>
                                    </button>
                                </span>
                            </mat-menu>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let user; columns: displayedColumns;"></tr>
                </table>
                <p *ngIf="dataSource && dataSource.data.length === 0" class="py-5 mb-0 text-center">Aucune données enregistrées</p>
            </div>
            <mat-paginator showFirstLastButtons [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
        </mat-card>
    </div>

</div> 
<div fxLayout="row" fxLayoutAlign="space-between" class="p-2" *ngIf="users.length">
    <mat-divider fxFlex="100" fxFlex.gt-md="50" fxFlex.md="100"></mat-divider>
    <div fxFlex="100" fxFlex.gt-md="50" fxFlex.md="100" style="text-align:center">
        Cliquez ci-dessous pour envoyer un Mail aux utilisateurs <br>
        <mat-icon (click)="sendEmailOfUsers(null)" color="primary" style="font-size:100px; width: 100px; height:100px; cursor:pointer">forward_to_inbox</mat-icon>
    </div>
    <mat-divider fxFlex="100" fxFlex.gt-md="50" fxFlex.md="100"></mat-divider>
</div>

<div *ngIf="users.length" fxLayout="row wrap">
    <div fxFlex="100" class="p-2"> 
        <mat-card class="p-0 text-center">           
            <pagination-controls class="theme-pagination" [autoHide]="autoHide" [maxSize]="maxSize" (pageChange)="onPageChanged($event)"></pagination-controls>
        </mat-card>
    </div>
</div>


<div *ngIf="!users.length" fxLayout="column" fxLayoutAlign="center center" class="user-spinner">   
    <mat-spinner color="primary"></mat-spinner>    
</div>
